import React from 'react';
import { FormControlLabel, Switch, TextField } from '@mui/material';
import { useField, useIsReadOnly } from '../../context';

/**
 * Opt-out toggle + message: a right-aligned Switch with the label before it, and
 * — only while enabled — a plain outlined single-line TextField.
 */
export const OptOutField: React.FC = () => {
  const enabled = useField('isOptOutEnabled');
  const text = useField('optOutText');
  const disabled = useIsReadOnly();

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            disabled={disabled}
            checked={!!enabled.value}
            onChange={(_, v) => {
              enabled.onChange(v);
              if (v) text.onChange('Reply STOP to opt-out');
            }}
            name="isOptOutEnabled"
          />
        }
        label="Include opt-out message"
        labelPlacement="start"
        style={{ marginLeft: 0, justifyContent: 'flex-end' }}
      />
      {enabled.value && (
        <TextField
          id="outlined-basic"
          label="Opt-out message"
          name="optOutText"
          variant="outlined"
          disabled={disabled}
          style={{ margin: '20px 0px' }}
          value={text.value ?? ''}
          onChange={e => text.onChange(e.target.value)}
        />
      )}
    </>
  );
};
